import type { RevenueDashboardResponse } from '@evi/shared';

type RecordedLocation = RevenueDashboardResponse['locations'][number];
export type RevenueLocationRow = Pick<RecordedLocation,
  'location_id' | 'location_name' | 'sessions' | 'billed_cents' | 'collected_cents' | 'evi_retained_cents' | 'excluded_sessions'> & {
  no_matching_sessions: boolean;
};

/** Keep scoped zero-activity selections in the comparison without inventing currency or changing totals. */
export function revenueLocationRows(data: Pick<RevenueDashboardResponse, 'locations' | 'locations_without_sessions'>, currency?: string): RevenueLocationRow[] {
  const rows: RevenueLocationRow[] = data.locations.filter(r => r.currency === currency).map(r => ({ ...r, no_matching_sessions: false }));
  const seen = new Set(data.locations.map(r => r.location_id));
  for (const location of data.locations_without_sessions ?? []) {
    if (seen.has(location.location_id)) continue;
    seen.add(location.location_id);
    rows.push({ ...location, sessions: 0, billed_cents: 0, collected_cents: 0, evi_retained_cents: 0,
      excluded_sessions: 0, no_matching_sessions: true });
  }
  return rows;
}
